import { PSEUDO_LOCALE } from './config';

const ACCENT_MAP: Record<string, string> = {
    a: 'à', A: 'À', b: 'ƀ', B: 'Ɓ', c: 'ç', C: 'Ç', d: 'đ', D: 'Đ',
    e: 'é', E: 'É', f: 'ƒ', F: 'Ƒ', g: 'ǵ', G: 'Ǵ', h: 'ȟ', H: 'Ȟ',
    i: 'ï', I: 'Ï', j: 'ĵ', J: 'Ĵ', k: 'ǩ', K: 'Ǩ', l: 'ĺ', L: 'Ĺ',
    m: 'ɱ', M: 'Ɱ', n: 'ñ', N: 'Ñ', o: 'ó', O: 'Ó', p: 'ṕ', P: 'Ṕ',
    q: 'ǫ', Q: 'Ǫ', r: 'ŕ', R: 'Ŕ', s: 'š', S: 'Š', t: 'ť', T: 'Ť',
    u: 'ü', U: 'Ü', v: 'ṽ', V: 'Ṽ', w: 'ẃ', W: 'Ẃ', x: 'ẋ', X: 'Ẋ',
    y: 'ý', Y: 'Ý', z: 'ž', Z: 'Ž',
};

export function isPseudoLocale(locale: string): boolean {
    return locale === PSEUDO_LOCALE;
}

export function pseudoize(msg: string): string {
    const { masked, tokens } = maskPlaceholders(msg);
    const accented = Array.from(masked).map((ch) => ACCENT_MAP[ch] ?? ch).join('');
    // Pad ~30% to surface fixed-width layout breakage (German text expansion territory).
    const padded = accented + '~~~~~~~';
    const wrapped = `⟦!!${padded}!!⟧`;
    return restorePlaceholders(wrapped, tokens);
}

export function pseudoizeMessages(messages: Record<string, string>): Record<string, string> {
    const out: Record<string, string> = {};
    for (const key in messages) {
        if (Object.prototype.hasOwnProperty.call(messages, key)) {
            out[key] = pseudoize(messages[key]);
        }
    }
    return out;
}

// ICU placeholders like {name}, {count, plural, one {#}} must survive untouched —
// otherwise react-intl fails to parse them.
function maskPlaceholders(msg: string): { masked: string; tokens: string[] } {
    const tokens: string[] = [];
    const masked = msg.replace(/\{[^{}]*\}/g, (m) => {
        const i = tokens.push(m) - 1;
        return `§${i}§`;
    });
    return { masked, tokens };
}

function restorePlaceholders(masked: string, tokens: string[]): string {
    return masked.replace(/§(\d+)§/g, (_, i) => tokens[parseInt(i, 10)] ?? '');
}
